// Environment configuration for switching between mock and real API calls
export const ENV_CONFIG = {
  // Set to true for local development with mocks, false for production
  USE_MOCKS: process.env.REACT_APP_USE_MOCKS === 'true',

  // API configuration
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'https://api.sage.com',

  // Environment type
  ENVIRONMENT: process.env.REACT_APP_ENV || process.env.NODE_ENV || 'development',

  // Debug logging
  DEBUG_LOGGING: process.env.REACT_APP_DEBUG === 'true' || process.env.NODE_ENV === 'development',
};
// Helper function to log environment configuration
export const logEnvironmentConfig = () => {
  if (ENV_CONFIG.DEBUG_LOGGING) {
  }
};

// Helper function to check if we're in mock mode
export const isMockMode = (): boolean => {
  return ENV_CONFIG.USE_MOCKS === true;
};

// Helper function to check if we're in development
export const isDevelopment = (): boolean => {
  return ENV_CONFIG.ENVIRONMENT === 'development' || ENV_CONFIG.ENVIRONMENT === 'local';
};
